$(document).ready(function() {

    $('#ttgMapModalList').on('shown.bs.modal', function() {
        toggleChatbot('hide');
    }).on('hidden.bs.modal', function() {
        toggleChatbot('show');
    });

    // LIST + DETAIL
    $('.ttgModalMapCloseButton').on('click', function(e) {
        e.preventDefault();
        closeDialog(this);
    });

    // Modal mit ESC schließen LIST
    $('body').on('keydown', '.ttgModalMapCloseButton', function(e) {
        var code = e.which;
        // 27 = ESC
        if ((code === 27)) {
            $(this).click();
        }
    });

});

const openMapsModalDetail = function() {

    $('#ttgMapModalDetail').modal('show');
    openDialog('ttgMapModalDetail', $('#ttgDetailKarteBtn'));

    // Iframe Höhe beim Resizen anpassen
    $(window).bind("resize", function(e) {
        if ($("#ttgModalMapIframe").length > 0 && $('#ttgMapModalList').length > 0) {
            var mh = $("#ttgMapModalDetail .modal-dialog").height();
            mh = parseInt(mh) - 100;
            $("#ttgModalMapIframe").css("height", mh + 'px');
        }
    });

    $('#ttgMapModalDetail').on('hidden.bs.modal', function(e) {
        // Chatbot einblenden
        toggleChatbot('show');
    });

    $('#ttgMapModalDetail').on('shown.bs.modal', function() {

        // Chatbot ausblenden
        toggleChatbot('hide');

        // Parameter für den Iframe
        let getParams = "&no_cache=1";
        getParams += "&sourceId=" + $('#ttgDetailKarte').data('sourceid');
        getParams += "&type=" + $('#ttgDetailKarte').data('metasourcecategory');
        getParams += "&sourceCategory=" + $('#ttgDetailKarte').data('sourcecategory');
        getParams += "&show=detail";
        if ($('#ttgDetailKarte').data('relations')) {
            getParams += "&show=relations";
            getParams += "&pins=" + $('#ttgDetailKarte').data('relations');
        }
        if ($('#ttgDetailKarte').data('metahash')) {
            getParams += "&metaHash=" + $('#ttgDetailKarte').data('metahash');
        }
        if ($('#ttgDetailKarte').data('lat') && $('#ttgDetailKarte').data('lon')) {
            getParams += "&lat=" + $('#ttgDetailKarte').data('lat');
            getParams += "&lon=" + $('#ttgDetailKarte').data('lon');
        }
        if ($('#ttgDetailKarte').data('mapsnoinfowindow')) {
            getParams += "&noInfoWindow=" + $('#ttgDetailKarte').data('mapsnoinfowindow');
        }

        if ($('#ttgDetailKarte').data('basedomain')) {
            getParams += "&baseDomain=" + $('#ttgDetailKarte').data('basedomain');
        }

        if ($('#ttgDetailKarte').data('terminal')) {
            getParams += "&terminal=1";
        }

        if ($.cookie('cookieConsented-analysis')) {
            getParams += "&consent-analysis=" + $.cookie('cookieConsented-analysis');
        }

        // aktuelle Sprache übergeben
        getParams += "&lang=" + $('html').attr('lang');

        // aktuell verwendete mapsConfig (LISTE)
        getParams += "&mapsConfig=" + $('#ttgDetailKarte').data('mapsconfig');

        let modalHeight = $("#ttgMapModalDetail .modal-dialog").height();
        modalHeight = parseInt(modalHeight) - 100;

        if ($('#tdAppBaseUrl').hasClass('ttg-webstream')) {
            setTimeout(function() {
                window.open($("#ttgDetailKarte").data('mapsmodaliframeurl') + getParams, '_blank');
            }, 50);
        } else {
            setTimeout(function() {
                let iFrameURL = '<iframe id="ttgModalMapIframe" src="' + $("#ttgDetailKarte").data('mapsmodaliframeurl') + getParams + '" border="0" style="height: ' + modalHeight + 'px;"></iframe>';
                $("#ttgModalMapDetailWrapper").html(iFrameURL);
            }, 50);
        }

    });
};

const toggleChatbot = function(modus) {

    if (modus == 'show') {
        // wenn der Onlim Chatbot aktiviert ist, soll dieser beim Schließen des Modals wieder eingebledet werden
        if ($('#onlim-chat-widget-trigger').length > 0) {
            $('#onlim-chat-widget-trigger').fadeIn();
        }
        if ($('#onlim-chat-widget-unread').length > 0) {
            $('#onlim-chat-widget-unread').fadeIn();
        }
    }

    if (modus == 'hide') {
        // wenn der Onlim Chatbot aktiviert ist, soll dieser beim Laden des Modals ausgeblendet
        if ($('#onlim-chat-widget-trigger').length > 0) {
            $('#onlim-chat-widget-trigger').fadeOut();
        }
        if ($('#onlim-chat-widget-unread').length > 0) {
            $('#onlim-chat-widget-unread').fadeOut();
        }
    }
};

// wenn das showOnMap Icon in der Liste geklickt wird
// $(document).on("click", ".ttgMapLinkDetail", function(e) {
//     //e.preventDefault();
//     //openMapsModal($(this).data("sourceid"));
// });

// wenn das die StaticMap auf der Detailseite geklickt wird
// $(document).on("click", "#ttgDetailKarte", function(e) {
//     //e.preventDefault();
//     //openMapsModalDetail($(this).data("sourceid"));
// });